var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "change_circle_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1587",
    "data-name": "Rectangle 1587",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8730",
    "data-name": "Path 8730",
    d: "M158.746,114.568l-7.26-5.928-1.38,1.787,4.775,3.886H138.319v2.269h19.737a1.133,1.133,0,0,0,1.049-.766,1.082,1.082,0,0,0-.359-1.248Z",
    transform: "translate(-136.746 -104.462)",
    fill: "#434db8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8731",
    "data-name": "Path 8731",
    d: "M161.762,294.56H142.507a1.146,1.146,0,0,0-1.048.737,1.113,1.113,0,0,0,.331,1.248l6.979,5.9,1.407-1.758-4.607-3.857h16.193Z",
    transform: "translate(-139.66 -280.294)",
    fill: "#434db8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeArrowBlue);
export default __webpack_public_path__ + "static/media/change_arrow_blue.4ad88b3012b79d40aae96da75a178d5f.svg";
export { ForwardRef as ReactComponent };